import type { ResultOf } from '@graphql-typed-document-node/core';
import { graphql } from 'src/gql';

export const ClientPortalBenchmarkComparisonQuery = graphql(/* GraphQL */ `
  query ClientPortalBenchmarkComparison($householdId: ID!, $dateRange: DateRangeInput!) {
    clientPortalBenchmarkComparisons(householdId: $householdId, dateRange: $dateRange) {
      label
      returnCumulative
      startDate
      endDate
    }
  }
`);

export type ClientPortalBenchmarkComparisonResult = ResultOf<typeof ClientPortalBenchmarkComparisonQuery>;

export type ClientPortalBenchmarkComparisons =
  ClientPortalBenchmarkComparisonResult['clientPortalBenchmarkComparisons'];

export type ClientPortalBenchmarkComparison = ClientPortalBenchmarkComparisons[number];
